
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/features",
      function () {
        return require("private-next-pages/[lang]/features/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/features"])
      });
    }
  